// timezone.js
export const getGuyanaDate = () => {
  return new Date().toLocaleDateString("en-CA", {
    timeZone: "America/Guyana",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }); // returns YYYY-MM-DD
};

export const getGuyanaDateTime = () => {
  return new Date().toLocaleString("en-CA", {
    timeZone: "America/Guyana",
  }); // returns full date and time
};

export const getFormattedGuyanaDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-CA", {
    timeZone: "America/Guyana",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
